module.exports = __webpack_public_path__ + "static/media/business.a563665b.svg";